import { BaseConfig } from "./base-config";

const generateDevelopmentConfig = () =>
    new BaseConfig({
        firebaseConfig: {
            apiKey: "AIzaSyCgpy1FTSluB_fDYZyTGcvRz2dWcCxsWjc",
            authDomain: "partner-portal-development.firebaseapp.com",
            projectId: "partner-portal-development",
            storageBucket: "partner-portal-development.firebasestorage.app",
            messagingSenderId: "521426088403",
            appId: "1:521426088403:web:d8f7cb03a23c16a0b8bf26",
        },
        jobPositionEmailRecipientLimit: 5,
        defaultApplicantManagerFirebaseUids: ["sm2OQJfjORR6vkSCDBrA4srgUT62"],
    });

export { generateDevelopmentConfig };
